export default {
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_LOADING: 'CHANGE_PASSWORD_LOADING',
  CHANGE_PASSWORD_REJECT: 'CHANGE_PASSWORD_REJECT',
  CHANGE_PASSWORD_FAILED: 'CHANGE_PASSWORD_FAILED'
};
